import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_PUBLISHABLE_KEY')
}

/**
 * Supabase Auth クライアント（認証のみに使う。データは自前の API から取る）
 *
 * セッションは localStorage に保存され、アクセストークン（1 時間）は自動で更新される。
 * サインアウトするまでセッションは切れない。
 */
export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    // OAuth の戻り URL にトークンではなく使い捨てのコードを載せる
    flowType: 'pkce',
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})

/** パスキーの Relying Party ID。Supabase ダッシュボードの設定と一致させる（変更すると登録済みのパスキーが使えなくなる） */
export const PASSKEY_RP_ID = 'private-media-lounge.com'

/** この端末・このドメインでパスキーが使えるか（RP ID 配下のドメイン以外では WebAuthn が拒否する） */
export const isPasskeyAvailableHere = (): boolean => {
  if (typeof window === 'undefined' || typeof window.PublicKeyCredential === 'undefined') return false
  const { hostname } = window.location
  return hostname === PASSKEY_RP_ID || hostname.endsWith(`.${PASSKEY_RP_ID}`)
}

/** ユーザーがパスキーの選択・作成画面を閉じた（エラーとして扱わない） */
export const isPasskeyCancelled = (error: Error): boolean =>
  error.name === 'NotAllowedError' || ('code' in error && error.code === 'ERROR_CEREMONY_ABORTED')
